export default "__VITE_ASSET__Bn6A8auK__"